import React, { useState } from "react";
import DesktopPrivacyStatement from "./components/DesktopPrivacyStatement";
import { TPrivacyStatementProps } from "./types/PrivacyStatement.types";
import useMediaQuery from "../../hooks/useMediaQuery";
import { BreakpointsInPx } from "../../constants/breakpoints.constants";
import MobilePrivacyStatement from "./components/MobilePrivacyStatement";
import './index.scss';

const PrivacyStatementV2 = (props: TPrivacyStatementProps) => {
    const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);
    const [activeItem, setActiveItem] = useState(0);
    

    return (
        <>
            {(isDesktop) ?
                <DesktopPrivacyStatement {...props} activeItem={activeItem} setActiveItem={setActiveItem}/> :
                <MobilePrivacyStatement {...props} activeItem={activeItem} setActiveItem={setActiveItem}/>
            }
        </>
    )
}

export default PrivacyStatementV2;